import { Button, Modal, Typography } from '@scale/scaleui';
import { useCallback } from 'react';
import { useRemoveWorkersFromSquad } from 'react-scale/components/ExpertManagement/hooks/mutations/useRemoveWorkersFromSquad';
import { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

interface DeleteWorkersConfirmationModalProps {
  onClose: () => void;
  open: boolean;
  refetch: () => Promise<void>;
  squadId: string;
  selectedRows: any[];
}

export function DeleteWorkersConfirmationModal({
  onClose,
  open,
  refetch,
  squadId,
  selectedRows,
}: DeleteWorkersConfirmationModalProps) {
  const { mutateAsync: removeWorkers, isLoading: removeWorkersLoading } =
    useRemoveWorkersFromSquad();

  const onDelete = useCallback(async () => {
    try {
      await removeWorkers({ squadId, workerIds: selectedRows.map((row: any) => row.id) });
      await refetch();
      onClose();
    } catch (e) {
      defaultApiFetchErrorHandler(e, { handleHttp: true });
    }
  }, [onClose, refetch, removeWorkers, selectedRows, squadId]);

  return (
    <Modal title="Edit Manager Info" open={open} onClose={onClose}>
      <div className="flex flex-col gap-2">
        <Typography.Subtitle2>Remove Workers from Squad</Typography.Subtitle2>
        <Typography.Paragraph2>
          Are you sure you want to remove the following workers from this squad?
        </Typography.Paragraph2>
        <ul>
          {selectedRows.map((row: any) => (
            <li key={row.id} className="font-bold">
              {row.name} ({row.email})
            </li>
          ))}
        </ul>
        <div>
          <Button disabled={removeWorkersLoading} onClick={onDelete} variant="danger">
            Remove Workers
          </Button>
        </div>
      </div>
    </Modal>
  );
}
